export const getSessionData = () => {
  try {
    const agentName = sessionStorage.getItem('agentName') || '';
    const agencyEmail = sessionStorage.getItem('agencyEmail') || '';
    return { agentName, agencyEmail };
  } catch {
    return { agentName: '', agencyEmail: '' };
  }
};
